import { render, staticRenderFns } from "./SecretAchievementTab.vue?vue&type=template&id=0471d14e&"
import script from "./SecretAchievementTab.vue?vue&type=script&lang=js&"
export * from "./SecretAchievementTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports